import React from 'react';
import Typography from '@mui/material/Typography';

const MarketsColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Market Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Description</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Website</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Market Location</Typography>
      </div>
    </>
  );
};

export default MarketsColumns;
